var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6L3 5C2.44772 4.44772 2.44772 3.55228 3 3C3.55228 2.44772 4.44771 2.44771 5 3L6 4L18 16C18.5523 16.5523 18.5523 17.4477 18 18C17.4477 18.5523 16.5523 18.5523 16 18L4 6Z",
    fill: "#B2C1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6L3 5C2.44772 4.44772 2.44772 3.55228 3 3V3C3.55228 2.44772 4.44771 2.44771 5 3L6 4M4 6L16 18C16.5523 18.5523 17.4477 18.5523 18 18V18C18.5523 17.4477 18.5523 16.5523 18 16L6 4M4 6L6 4",
    stroke: "#090B45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6L3 5C2.44772 4.44772 2.44772 3.55228 3 3C3.55228 2.44772 4.44771 2.44771 5 3L6 4L18 16C18.5523 16.5523 18.5523 17.4477 18 18C17.4477 18.5523 16.5523 18.5523 16 18L4 6Z",
    fill: "#B2C1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6L3 5C2.44772 4.44772 2.44772 3.55228 3 3V3C3.55228 2.44772 4.44771 2.44771 5 3L6 4M4 6L16 18C16.5523 18.5523 17.4477 18.5523 18 18V18C18.5523 17.4477 18.5523 16.5523 18 16L6 4M4 6L6 4",
    stroke: "#090B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 15C4 14.5 4.5 14 5 12C5.5 14 6 14.5 8 15C6 15.5 5.5 16 5 18C4.5 16 4 15.5 2 15Z",
    fill: "white",
    stroke: "#090B45",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3.5C10.6667 3.08333 11.0833 2.66667 11.5 1C11.9167 2.66667 12.3333 3.08333 14 3.5C12.3333 3.91667 11.9167 4.33333 11.5 6C11.0833 4.33333 10.6667 3.91667 9 3.5Z",
    fill: "white",
    stroke: "#090B45",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5C15.6667 5.08333 16.0833 4.66667 16.5 3C16.9167 4.66667 17.3333 5.08333 19 5.5C17.3333 5.91667 16.9167 6.33333 16.5 8C16.0833 6.33333 15.6667 5.91667 14 5.5Z",
    fill: "white",
    stroke: "#090B45",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6L3 5C2.44772 4.44772 2.44772 3.55228 3 3C3.55228 2.44772 4.44771 2.44771 5 3L6 4L4 6Z",
    fill: "white",
    stroke: "#090B45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWandIcon);
export default __webpack_public_path__ + "static/media/wand-icon.842fa8526500da5749472b50e1b544f9.svg";
export { ForwardRef as ReactComponent };